import { ImageLoaderProps } from "next/image";

export default ({ src, width, quality }: ImageLoaderProps) => {
  const url = new URL(src);

  if (url.host !== "a.storyblok.com" && url.host !== "a-us.storyblok.com") {
    return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`;
  }

  if (src.includes("svg")) return src;

  const focus = url.searchParams.get("focus");
  url.searchParams.delete("focus");

  const filters = [];
  if (focus) filters.push(`focal(${focus})`);
  filters.push(`format(avif)`);
  // filters.push(`quality(${quality || 50})`);
  filters.push(`quality(50)`);

  return `${url.origin}${url.pathname}/m/${width}x0${filters.length ? `/filters:${filters.join(":")}` : ""}`;
};
